<template>
  <svg width="91" height="91" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#a)">
      <path
        d="M28.328 48.305v.812M28.328 50.617v.812M26.766 49.867h.812M29.078 49.867h.812M33.594 42.746v1.488M33.594 46.988v1.489M30.727 45.613h1.485M34.969 45.613h1.486M52.922 43.148v1.348M52.922 46.996v1.348M50.328 45.746h1.348M54.172 45.746h1.35M59.445 66.785h3.791v-4.457M63.236 60.382v-1.026H55.53v4.231"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        clip-rule="evenodd"
        d="M60.066 52.105h-1.361l-2.627 4.176h6.614l-2.626-4.175Z"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M55.531 63.09h7.705"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M58.047 59.355h2.565a.829.829 0 0 1-.827.828h-.91a.829.829 0 0 1-.828-.828ZM58.063 63.09h2.565a.829.829 0 0 1-.828.828h-.91a.829.829 0 0 1-.828-.828Z"
        fill="#2E2E2E"
      />
      <path
        d="M60.28 56.281h-1.796v3.072h1.797v-3.072ZM52.019 60.714l9.137 7.476H25.28l9.434-7.717"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="m34.715 60.473-9.434 7.717h35.875l-9.137-7.476"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M26.364 71.184h-.96a.56.56 0 0 0-.56.56v5.128c0 .31.252.56.56.56h1.326a.56.56 0 0 0 .56-.56c0-.31.252-.56.56-.56h30.677c.31 0 .56.252.56.56 0 .31.252.56.56.56h1.326a.56.56 0 0 0 .56-.56v-5.129a.56.56 0 0 0-.56-.56H26.364Z"
        fill="#2E2E2E"
      />
      <path
        d="M25.281 68.191h35.875v3.256H25.28V70.08M32.656 62.157v-5.744a5.014 5.014 0 0 1 5.014-5.015h11.186a5.014 5.014 0 0 1 5.014 5.015v5.619"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M46.137 53.25h-8.185c-1.759 0-3.186 1.356-3.186 3.03"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        clip-rule="evenodd"
        d="m42.92 63.044.008-.027c.014-.042.024-.082.035-.125v-.005c.239-.9.215-1.852.12-2.616-.11-.88-.309-1.51-.309-1.51-3.977-1.093-7.43-.044-7.569 0H35.2l-.04.125c0 .008-.005.016-.008.024l-.032.109c0 .005-.002.01-.005.016-.393 1.43-.202 2.995-.048 3.823 0 .013.006.027.008.04v.01c.032.162.059.292.082.382.006.027.014.05.016.07l.022.087h.005a.05.05 0 0 1 .018.005h.006l.077.021.087.024.109.03c.027.008.056.013.082.02.133.033.266.062.398.09.024.006.045.011.07.014l.121.024a11.078 11.078 0 0 0 .49.08c.02 0 .036.005.054.008.043.005.088.01.13.018.019 0 .037.005.059.008a12.039 12.039 0 0 0 .477.05l.127.011c.019 0 .04.003.059.005l.127.008h.03c.087.006.174.011.262.014h.053c.04 0 .082.002.122.005h.064c.04 0 .082 0 .122.003h.045l.241.002h.091c2.082 0 3.788-.387 4.019-.44.01 0 .018-.005.021-.005.021-.053.04-.104.058-.157l.043-.117c0-.005.003-.01.005-.016.014-.04.024-.077.037-.116l.016.008Z"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M47.968 58.268c-2.324-.042-3.988.462-4.083.494h-.005l-.04.124c0 .008-.006.016-.008.024l-.032.109c0 .005-.003.01-.005.016-.393 1.43-.202 2.995-.048 3.823 0 .013.005.027.008.04v.01c.032.162.058.292.082.382.005.027.013.05.016.07l.021.087h.006a.05.05 0 0 1 .018.005h.005l.077.022.088.023.109.03c.026.008.055.013.082.02.133.033.265.062.398.091.024.005.045.01.069.013l.122.024a10.885 10.885 0 0 0 .49.08c.02 0 .035.005.054.008.042.005.087.01.13.018.018 0 .037.005.058.008.144.019.287.032.43.045.016 0 .032.003.048.006.042.002.085.008.127.01.019 0 .04.003.058.005l.128.009h.029c.087.005.175.01.263.013h.053c.04 0 .082.002.122.005h.063c.04 0 .083 0 .122.003h.046l.241.002h.09c2.083 0 3.789-.387 4.02-.44.01 0 .018-.005.02-.005.022-.053.04-.104.06-.157.012-.04.028-.08.042-.117 0-.005.002-.01.005-.016l.037-.116.008-.027c.013-.042.024-.082.035-.124v-.006c.512-1.934-.189-4.125-.189-4.125a13.893 13.893 0 0 0-1.475-.319"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M28.953 34.906h30.21a8.202 8.202 0 0 1 8.204 8.203v39.215H20.75V44.988"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M54.647 34.803V19.89c0-5.797-4.698-10.495-10.495-10.495-5.797 0-10.496 4.698-10.496 10.495v4.696M67.367 77.432v-36.72a5.805 5.805 0 0 0-5.805-5.806H26.555a5.805 5.805 0 0 0-5.805 5.805"
        stroke="#462170"
        stroke-width="8.711"
        stroke-miterlimit="10"
      />
      <path
        d="M66.15 45.184a.92.92 0 0 0-.167-1.207.739.739 0 0 0-1.104.146.787.787 0 0 0-.098.194.74.74 0 0 1 .931.037.924.924 0 0 1 .266 1.013.723.723 0 0 0 .175-.183h-.003Z"
        fill="#2E2E2E"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="m72.94 57.046-9.93-8.288a.79.79 0 0 1-.231-.329l-1.048-2.85a.788.788 0 0 1 .085-.72l2.695-3.89a.844.844 0 0 0-.077.09l-2.894 4.173a.805.805 0 0 0-.085.722l1.048 2.85a.782.782 0 0 0 .23.328l9.931 8.288a.643.643 0 0 0 .96-.127l.197-.284a.642.642 0 0 1-.884.035l.003.002Z"
        fill="#2E2E2E"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M78.383 49.194a.8.8 0 0 1 .146 1.05l-4.63 6.678a.643.643 0 0 1-.96.128l-9.93-8.288a.789.789 0 0 1-.23-.33l-1.049-2.849a.788.788 0 0 1 .085-.721l2.895-4.174a.644.644 0 0 1 .61-.28l2.783.347a.684.684 0 0 1 .35.153l9.93 8.289v-.003Zm-13.336-3.866a.739.739 0 0 0 1.103-.145.92.92 0 0 0-.167-1.208.739.739 0 0 0-1.104.146.923.923 0 0 0 .168 1.207Z"
        fill="#FAFAFD"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M51.707 31.414c-.066.56-.103 1.59.496 2.666 1.627 2.921 5.978 2.71 9.875 6.187 1.165 1.04 2.428 2.531 3.462 4.725"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M69.007 47.033c-.018-.31.096-.619.343-.92.247-.303.522-.478.83-.524.308-.045.6.046.876.268.276.223.422.491.44.804.019.313-.095.618-.342.92-.247.303-.523.476-.83.523-.308.046-.6-.042-.876-.267-.276-.226-.422-.494-.44-.804Zm1.192.41c.135-.047.268-.153.4-.312a.921.921 0 0 0 .223-.449.36.36 0 0 0-.14-.352.363.363 0 0 0-.377-.067.924.924 0 0 0-.395.31c-.128.16-.207.314-.229.454a.367.367 0 0 0 .141.356.359.359 0 0 0 .377.066v-.005Zm2.616-.15.591.483L68.06 50.3l-.591-.483 5.346-2.525Zm-3.423 3.645c-.018-.31.096-.616.343-.92.246-.306.522-.478.83-.523.308-.045.6.045.875.268.276.225.422.49.44.804.02.31-.095.618-.341.92-.247.303-.523.478-.83.523-.309.045-.6-.043-.876-.268-.276-.226-.422-.494-.44-.804Zm1.191.411c.136-.047.268-.154.401-.316a.933.933 0 0 0 .223-.448.36.36 0 0 0-.14-.353.364.364 0 0 0-.377-.066.932.932 0 0 0-.396.308.984.984 0 0 0-.228.456.36.36 0 0 0 .14.353.363.363 0 0 0 .377.066Z"
        fill="#2E2E2E"
      />
      <path
        d="M54.153 30.679V19.756a8.314 8.314 0 0 0-8.315-8.315 8.314 8.314 0 0 0-8.315 8.315v3.72"
        stroke="#2E2E2E"
        stroke-width="1.694"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="a"><path fill="#fff" d="M0 0h91v91H0z" /></clipPath>
    </defs>
  </svg>
</template>
